<template>
  <v-card v-if="is_loaded" tile elevation="0">
    <v-row class="d-flex">
      <v-col cols="12" lg="5" md="5" xs="12" class="d-flex flex-column">
        <v-card-title class="text_primary pb-0"> 方案 </v-card-title>
        <v-card-text>
          <div class="tbl-col tbl-f mt-3">
            <div class="c-row mobile span2C pb-2">
              <div class="c-col mobile w12">
                <div class="c-th th-f">{{ level.name !== 'Disable' ? level.name : '已到期' }}</div>

                <div v-if="level.level !== 0 && level.level !== -1" class="c-th th-f price">
                  ${{ level.add_column.price }}
                </div>
                <div v-else-if="level.level === 0" class="c-th th-f price">免費試用7天</div>
                <div v-if="subscribtion_info.sub_end_at" style="color: #000000">
                  到期日: {{ subscribtion_info.sub_end_at.split(' ')[0] }}
                </div>

                <v-alert
                  v-if="
                    (quota_info.level === 'free' ||
                      quota_info.level === 'disable' ||
                      getRemainingdays(quota_info) <= 14) &&
                    quota_info.level !== 'nineder'
                  "
                  type="warning"
                  color="warning"
                  class="my-2"
                  density="compact"
                  border-color="orange-darken-2"
                  icon="mdi-open-in-new"
                  style="font-size: 14px; cursor: pointer"
                  dense
                  @click="goToUpgradePlan"
                >
                  <template
                    v-if="
                      quota_info.level === 'free' ||
                      quota_info.level === 'disable' ||
                      getRemainingdays(quota_info) <= subscription_thredhold
                    "
                  >
                    查看訂閱方案
                  </template>
                  <template v-else> 升級方案 </template>
                </v-alert>
              </div>
            </div>

            <template v-for="(category, idx) in subscription_trees.categories">
              <div :key="`c_${idx}`" class="c-row">
                <div class="c-thead wadj">
                  <h1 class="c-h1">{{ category ? category.name : '' }}</h1>
                </div>
              </div>

              <div v-if="category.category.length > 0" :key="`d_${level.level}_${idx}`">
                <template v-for="(sub_category, f_idx) in category.category">
                  <div
                    :key="`f_${f_idx}`"
                    class="c-row mobile category"
                    style="cursor: pointer"
                    @click="activateDetails(sub_category.name)"
                  >
                    <div class="c-td category-name w5" :category="`${sub_category.name}`">
                      <span class="c-arrow"> ▼ </span>
                      {{ sub_category.name }}
                    </div>

                    <div
                      v-if="
                        sub_category.features[0].function.includes('Release') ||
                        sub_category.features[0].function.includes('Activate')
                      "
                      class="c-col mobile"
                    >
                      <div v-if="!addon[sub_category.features[0].function]" class="c-th c-td-title">
                        {{ getLevelQuota(sub_category.features[0], level).remaining }}
                      </div>
                      <div v-else class="c-th c-td-title" style="position: relative">
                        {{
                          getLevelQuota(sub_category.features[0], level).remaining +
                          addon[sub_category.features[0].function]
                        }}
                      </div>
                    </div>
                  </div>

                  <div
                    v-for="(feature, feature_idx) in sub_category.features"
                    :key="`f4_${feature.function}_${feature_idx}`"
                    :category="`${sub_category.name}`"
                    class="c-row mobile"
                  >
                    <div class="c-td feature-name w5">
                      <span>{{ feature.name }}</span>

                      <v-tooltip v-if="feature.memo" right color="white">
                        <template #activator="{ on, attrs }">
                          <v-btn class="ml-2" icon x-small v-bind="attrs" v-on="on">
                            <v-icon color="white"> mdi-information-variant-circle </v-icon>
                          </v-btn>
                        </template>
                        <span class="black--text">{{ feature.memo }}</span>
                      </v-tooltip>
                    </div>

                    <div class="c-col mobile w2">
                      <template v-if="!addon[feature.function]">
                        <div v-if="feature.type !== 'boolean'">{{ getLevelQuota(feature, level).remaining }}</div>
                        <div v-else>
                          <span v-if="getLevelQuota(feature, level).remaining === 1">✅</span>
                          <span v-else>❌</span>
                        </div>
                      </template>
                      <template v-else>
                        <div v-if="feature.type !== 'boolean'" style="position: relative">
                          <span class="white--text">{{
                            getLevelQuota(feature, level).remaining + addon[feature.function]
                          }}</span>
                          <v-tooltip right color="white">
                            <template #activator="{ on, attrs }">
                              <v-btn style="position: absolute" class="ml-2" icon x-small v-bind="attrs" v-on="on">
                                <v-icon color="yellow"> mdi-star-plus-outline </v-icon>
                              </v-btn>
                            </template>
                            <span class="black--text">{{
                              `${getLevelQuota(feature, level).remaining} + ${addon[feature.function]} (加購)`
                            }}</span>
                          </v-tooltip>
                        </div>
                        <div v-else>
                          <span v-if="addon[feature.function] === 1">✅</span>
                          <span v-else>❌</span>
                          <v-tooltip v-if="addon[feature.function] === 1" right color="white">
                            <template #activator="{ on, attrs }">
                              <v-btn
                                v-if="addon[feature.function] === 1"
                                style="position: absolute"
                                class="ml-2"
                                icon
                                x-small
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon color="yellow"> mdi-star-plus-outline </v-icon>
                              </v-btn>
                            </template>
                            <span class="black--text">{{ `加購啟用` }}</span>
                          </v-tooltip>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>

              <div
                v-if="category.features && category.features.length > 0"
                :key="`d_${level.level}_${idx}`"
                class="c-row mobile"
              >
                <template v-for="(feature, f_idx) in category.features">
                  <div
                    :key="`${feature.function}_${f_idx}`"
                    class="c-td feature-name w5"
                    @click="editFeatureName(feature)"
                  >
                    {{ feature.name }}
                  </div>

                  <div :key="`p_${feature.function}_${f_idx}`" class="c-col mobile">
                    <div class="">{{ getLevelQuota(feature, level).remaining }}</div>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </v-card-text>
      </v-col>

      <v-col cols="12" lg="7" md="7" xs="12" class="d-flex flex-column">
        <v-card-title class="text_primary pb-0 pl-0 mb-5"> 在線使用數 </v-card-title>
        <!-- {{limit_mapper}} -->
        <!-- {{limit_mapper[selected_duration_function.value]}} -->

        <div class="mb-6">
          <v-row>
            <v-col cols="12" lg="6" md="6" xs="6" class="pt-0 pb-0">
              <h5 class="subtitle-2 pa-0">
                開始時間
                <span class="error-message">(必填)</span>
              </h5>
              <div>
                <!-- {{start_at}} -->
                <date-picker
                  v-model="start_at"
                  :shortcuts="$utils.date_picker_shorcuts"
                  style="width: 100%"
                  type="datetime"
                  value-type="format"
                  format="YYYY-MM-DD"
                  @change="getData()"
                >
                </date-picker>
              </div>
            </v-col>
            <v-col cols="12" lg="6" md="6" xs="6" class="pt-0 pb-0">
              <h5 class="subtitle-2 pa-0">
                結束時間
                <span class="error-message">(必填)</span>
              </h5>
              <div>
                <!-- {{end_at}} -->
                <date-picker
                  v-model="end_at"
                  :shortcuts="$utils.date_picker_shorcuts"
                  style="width: 100%"
                  type="datetime"
                  value-type="format"
                  format="YYYY-MM-DD"
                  @change="getData()"
                >
                </date-picker>
              </div>
            </v-col>
          </v-row>
        </div>
        <div>
          <v-select
            v-model="selected_duration_function"
            outlined
            dense
            hide-details
            :items="duration_functions"
            return-object
            @change="getData()"
          >
          </v-select>
        </div>
        <v-card :key="table_key" class="mt-3">
          <!-- {{chartDatas}} -->
          <LineChartGenerator class="line-chart-container" :chart-options="chartOptions" :chart-data="chartDatas" />
        </v-card>
        <!-- <UsedQuotaInfo
                    v-if="is_loaded"
                    :service="subscription_mapper['ReleaseExperienceRemaining']['name']"
                    :usage="subscription_mapper['ReleaseExperienceRemaining']['usage']"
                    :limit="subscription_mapper['ReleaseExperienceRemaining']['limit']"
                    :is_show_percentbar="false"
                />
                
                <LineChartGenerator
                    class="line-chart-container"
                    :chart-options="chartOptions"
                    :chart-data="chartDatas"
                /> -->
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-tw'
// import LoadingOverlay from "@/components/Utils/LoadingOverlay.vue"
// import UsedQuotaInfo from "@/components/Utils/UsedQuotaInfo.vue";

// import GanttChart from "@/components/Utils/GanttChart.vue"
import { apiGetSubscriptionInfoWithData } from '@/api/organize.js'
import { apiGetSubscriptionTree } from '@/api/subcription.js'

// import { Bar } from 'vue-chartjs'
// 圖表套件
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from 'chart.js'

ChartJS.register([Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement])
export default {
  name: 'StaffMemberLevel',
  components: {
    LineChartGenerator,
    DatePicker,
    // // LoadingOverlay,
    // UsedQuotaInfo
    // GanttChart,
    // Bar
  },
  data() {
    return {
      is_loaded: false,
      subscription_mapper: {
        ContainerRemaining: {
          name: '可建立容器數',
          type: 'number',
        },
        ReleaseExperienceRemaining: {
          name: '單日可運行實驗數',
          type: 'number',
        },
        HistoryExperienceRemaining: {
          name: '可建立實驗數',
          type: 'number',
        },
        AbTestingRemaining: {
          name: '實驗版本上限',
          type: 'number',
        },
        ViewPriorityUpdatable: {
          name: '實驗版本權重調整',
          type: 'boolean',
        },
        AnalysisCart: {
          name: '購物車分析',
          type: 'boolean',
        },
        AnalysisOrderAmount: {
          name: '訂單數分析',
          type: 'boolean',
        },
        AnalysisPlaceAnOrder: {
          name: '下單分析',
          type: 'boolean',
        },
        ActivateSalesCardRemaining: {
          name: '單日可運行圖卡數',
          type: 'number',
        },
        SalesCardHistoryRemaining: {
          name: '可建立圖卡數',
          type: 'number',
        },
      },
      x_labels: [],

      subscriptionInfo: [
        // {
        //     text: '方案價格',
        //     value: 999,
        //     level: null
        // },
        {
          text: '可使用容器數',
          value: null,
          function: 'ContainerRemaining',
        },
        {
          text: '可發布實驗數',
          value: null,
          function: 'ReleaseExperienceRemaining',
        },
        {
          text: '可保留歷史實驗數',
          value: null,
          function: 'HistoryExperienceRemaining',
        },
        {
          text: 'A/B Test 可使用數',
          value: null,
          function: 'AbTestingRemaining',
        },
        {
          text: '版本權重',
          value: null,
          function: 'ViewPriorityUpdatable',
        },
        {
          text: '購物車分析',
          value: null,
          function: 'AnalysisCart',
        },
        {
          text: '訂單數分析',
          value: null,
          function: 'AnalysisOrderAmount',
        },
        {
          text: '下單分析',
          value: null,
          function: 'AnalysisPlaceAnOrder',
        },
        // {
        //     text: '計費週期',
        //     value: '每月'
        // }
      ],
      chartDatas: {
        labels: [],
        datasets: [
          {
            label: '日運行',
            data: [],
            borderColor: '#E1BEE7',
            tension: 0.5,
            backgroundColor: '#CE93D8',
            spanGaps: true,
            fill: true,
            borderWidth: 4,
          },
          {
            label: '上限',
            data: [],
            fill: false,
            borderColor: 'orange',
            tension: 1,
            backgroundColor: 'orange',
            spanGaps: true,
            borderWidth: 4,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            ticks: {
              callback: this.customLabelX,
            },
          },
          y: {
            ticks: {
              stepSize: 1, // 设置刻度间距为 1
              beginAtZero: true, // 从零开始
            },
          },
        },
        plugins: {
          legend: {
            position: 'top',
          },
          // tooltip: {
          //     callbacks: {
          //         title: function(title_text){
          //             console.log(title_text)
          //             return
          //         }
          //     }
          // }
        },
        // plugins: {

        //     // tooltips: {
        //     //     enabled: true,
        //     //     callbacks: {
        //     //         title: function(tooltipItem, chartData) {
        //     //             console.log('tooltipItem', tooltipItem)
        //     //             console.log('chartData',chartData)
        //     //             return "Title";
        //     //         }
        //     //     }
        //     // }
        // }

        // indexAxis: 'y',
        // scales: {
        //     y: {
        //         beginAtZero: true
        //     }
        // }
      },

      // 預設先幫使用者帶好一個選項
      goal: '可發布實驗數',

      // 會員訂閱資訊
      subscribtion_info: null,

      // 使用%數
      usedPercent: '35',

      limit: null,

      usedQuantity: null,

      level_mapper: {
        free: 0,
        starter: 10,
        business: 20,
        enterprise: 30,
        nineder: 99,
        disable: -1,
        '-1': 'Disable',
        0: 'Free',
        10: 'Starter',
        20: 'Business',
        30: 'Enterprise',
        99: 'Nineder',
      },

      level: 0,

      addon: {},
      limit_mapper: {},

      selected_duration_function: {
        text: 'AB test',
        value: 'ReleaseExperienceRemaining',
      },
      duration_functions: [
        {
          text: 'AB test',
          value: 'ReleaseExperienceRemaining',
        },
        {
          text: '衝動外掛',
          value: 'UrlViewActivate',
        },
        {
          text: '行銷圖卡',
          value: 'ActivateSalesCardRemaining',
        },
      ],
      table_key: 0,

      start_at: '',
      end_at: '',
      subscription_thredhold: process.env.VUE_APP_SUBSCRIPTION_EXPIRED_DAY,
    }
  },
  computed: {
    quota_info() {
      return this.$store.getters.memberQuota[this.$route.params.org_id]
    },
  },
  watch: {
    // chartDatas: {
    //     handler: function(newVal) {
    //         console.log(newVal)
    //         if (newVal) {
    //             this.chartDatas = JSON.parse(JSON.stringify(newVal))
    //         }
    //     },
    //     deep: true
    // }
  },
  async created() {
    this.is_loaded = false
    this.start_at = this.$utils.getYYYYMMDDHHMMSS(this.$utils.calculateDate(-30).toISOString(), '-').split(' ')[0]
    this.end_at = this.$utils.getYYYYMMDDHHMMSS(this.$utils.calculateDate(30).toISOString(), '-').split(' ')[0]
    await this.getData()
    this.is_loaded = true
  },
  async mounted() {},
  methods: {
    async getData() {
      // let that = this

      try {
        this.subscribtion_info = await apiGetSubscriptionInfoWithData(
          this.$route.params.org_id,
          this.start_at,
          this.end_at
        )

        this.subscription_trees = await apiGetSubscriptionTree()

        let level_key = this.level_mapper[this.subscribtion_info.level]
        console.log('level_key', level_key)
        this.level = this.subscription_trees.level_headers.find(function (header) {
          return header.level === level_key
        })
        let addon_mapper = {}
        let limit_mapper = {}
        this.subscribtion_info.quotaVo.forEach(function (quota) {
          limit_mapper[quota.function] = quota.limit
          if (quota.addon) {
            addon_mapper[quota.function] = quota.addon
          }
        })
        this.addon = addon_mapper
        this.limit_mapper = limit_mapper
        console.log('subscribtion_info', this.subscribtion_info)
        console.log('subscription_tree', this.subscription_trees)
        console.log('level', this.level)
        console.log('this.addon', this.addon)

        this.renderChart()

        // // await this.dataMapping()
        // // await this.atRenderChart()
        // // await this.generateLabels()
      } catch (e) {
        this.is_loaded = true
        console.log(e)
        this.$root.vtoast.show({ message: e.name + ': ' + e.message, color: 'error' })
      }
    },
    renderChart() {
      let that = this

      let date_ranges = this.$utils.getCustomDateRange(this.start_at, this.end_at, '-')
      console.log('data_ranges', date_ranges)

      that.chartDatas['labels'] = []
      that.chartDatas['datasets'][0]['data'] = []
      that.chartDatas['datasets'][1]['data'] = []
      date_ranges.forEach(function (date_range) {
        console.log('date_range', date_range)
        that.chartDatas['labels'].push(date_range)
        let limit = that.limit_mapper[that.selected_duration_function.value]
        if (that.addon[that.selected_duration_function.value]) {
          limit += that.addon[that.selected_duration_function.value]
        }
        that.chartDatas['datasets'][1]['data'].push(limit)

        let date_usage = that.subscribtion_info.duration_usage.find(function (duration_usage) {
          return (
            duration_usage.function === that.selected_duration_function.value &&
            duration_usage.date === `${date_range} 00:00:00`
          )
        })

        let use = 0
        if (date_usage) {
          use = date_usage.cnt
        }
        that.chartDatas['datasets'][0]['data'].push(use)
      })
      // this.subscribtion_info.duration_usage.forEach(function(date_usage){
      //     console.log('that.selected_duration_function.value',that.selected_duration_function.value)
      //     if (date_usage['function'] === that.selected_duration_function.value) {
      //         console.log("date_usage", date_usage)
      //         let date = date_usage.date.split(' ')[0]
      //         that.chartDatas['labels'].push(date)
      //         that.chartDatas['datasets'][0]['data'].push(date_usage.cnt)
      //         let limit = that.limit_mapper[date_usage['function']]
      //         if (that.addon[date_usage['function']]) {
      //             limit += that.addon[date_usage['function']]
      //         }
      //         that.chartDatas['datasets'][1]['data'].push(limit)
      //     }

      // })
      this.table_key += 1
    },
    activateDetails(category_name) {
      console.log('category_name', category_name)
      let category_features = Array.from(document.querySelectorAll(`.c-row[category="${category_name}"]`))
      let category_arrow = document.querySelector(`.category-name[category="${category_name}"] > .c-arrow`)
      if (!category_features && !category_arrow) {
        return
      }
      let is_deactivate = category_arrow.className.includes('deactivate-detail')
      if (is_deactivate) {
        category_arrow.classList.remove('deactivate-detail')
        category_arrow.innerText = '▼'
        category_features.forEach(function (category_feature) {
          category_feature.classList.remove('deactivate-detail')
        })
      } else {
        category_arrow.classList.add('deactivate-detail')
        category_arrow.innerText = '►'
        category_features.forEach(function (category_feature) {
          category_feature.classList.add('deactivate-detail')
        })
      }
    },

    mapFeatures: function (subscribtion_info) {
      let that = this
      console.log('subscribtion_info', subscribtion_info)
      //
      subscribtion_info.quotaVo.forEach(function (feature) {
        if (that.subscription_mapper[feature.function]) {
          that.subscription_mapper[feature.function]['limit'] = feature.limit
          that.subscription_mapper[feature.function]['addon'] = 0
          if (feature.addon) {
            that.subscription_mapper[feature.function]['addon'] = feature.addon
          }
          that.subscription_mapper[feature.function]['id'] = feature.function
        }
      })

      subscribtion_info.usage.forEach(function (feature) {
        if (that.subscription_mapper[feature.function]) {
          that.subscription_mapper[feature.function]['usage'] = feature.usage
        }
      })
    },
    getLevelColor: function (level) {
      let color_text = ''

      switch (level) {
        case 0:
          color_text = 'grey'
          break
        case 10:
          color_text = 'green'
          break
        case 20:
          color_text = 'blue'
          break
        case 30:
          color_text = 'purple'
          break
        case 99:
          color_text = '#d31734'
          break
        default:
          color_text = '#CCCCCC'
          break
      }

      return color_text
    },
    customLabelX(value, idx) {
      // console.log('WWWWWmfanif' ,idx)
      // console.log('this.chartDatas',this.chartDatas['labels'])
      let day_texts = this.chartDatas['labels'][idx].split('-')
      let day_text = day_texts[day_texts.length - 1]
      return day_text
    },
    // 組織訂閱資訊分類
    dataMapping() {
      // this.subscribtion_info['quotaVo'].forEach( item => {
      //     this.subscriptionInfo.forEach(field => {
      //         if (item['function'] === field?.['function']) {
      //             field['value'] = item['limit']
      //         }

      //     })
      // })
      this.subscriptionInfo = this.subscriptionInfo.map((subscription) => {
        const quotaItem = this.subscribtion_info['quotaVo'].find(
          (quota) => quota['function'] === subscription['function']
        )
        return quotaItem ? { ...subscription, value: quotaItem['limit'] } : subscription
      })
      this.subscriptionInfo[0]['level'] = this.subscribtion_info['level']
    },
    generateLabels() {
      let currentDate = new Date()
      let date
      for (let i = 0; i < 30; i++) {
        date = new Date(currentDate.getTime() - i * 24 * 60 * 60 * 1000)
        // console.log(date.getDate());
        this.chartDatas['labels'].push(date.getDate())
      }
      this.chartDatas['labels'].reverse()
      console.log(this.chartDatas['labels'])
    },
    generateDatas() {
      console.log('yayayayyayaya')
      let random
      this.chartDatas['datasets'][0]['data'] = []
      for (let i = 0; i < 30; i++) {
        random = Math.floor(Math.random() * 10000000) + 1
        this.chartDatas['datasets'][0]['data'].push(Number(random))
      }
      this.chartDatas['datasets'][1]['data'] = []
      for (let i = 0; i < 30; i++) {
        this.chartDatas['datasets'][1]['data'].push(Number(this.limit))
      }
      console.log(this.chartDatas['datasets'])

      // console.log(this.chartDatas['datasets'][0]['data']);
      // console.log(this.chartDatas['datasets'][1]['data']);
    },
    async atRenderChart() {
      console.log('goal', this.goal)
      const selectedItem = await this.subscriptionInfo.find((item) => item['text'] === this.goal)
      this.limit = await selectedItem['value']
      console.log(this.limit)
      await this.generateDatas()
    },
    async goToUpgradePlan() {
      console.log('升級')
      let url = process.env.VUE_APP_HOME_PAGE + '/categories/products'
      window.open(url, '_blank')
    },
    getLevelQuota(feature, level) {
      console.log('level_quota', level)
      console.log('level_quota', feature)
      let level_quota = feature.levelRemainingRes.find(function (levelRemaining) {
        return levelRemaining.level === level.level
      })
      console.log('level_quota', level_quota)
      return level_quota
    },
    getRemainingdays(quota) {
      let sub_end_at = new Date(quota.sub_end_at).getTime()
      let now = new Date().getTime()
      let msDiff = sub_end_at - now // 還有多久（毫秒）
      let daysLeft = Math.floor(msDiff / (1000 * 60 * 60 * 24)) // 換算成天數，並無條件進位
      return daysLeft
    },
  },
}
</script>

<style scoped>
.selected-active {
  color: red;
}
/* .line-chart-container {
        height: calc(100% - 100px);
    } */
</style>

<style scoped>
.level-wrapper {
  background-color: #000;
}
.tbl-col {
  display: flex;
  flex-flow: column nowrap;
  overflow: auto;
  margin: auto;
}
.tbl-f {
  font-size: 95%;
  width: 100%;
}
.c-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.c-col.mobile {
  flex: 1;
}
.c-row {
  background-color: #343434;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.c-row.mobile {
  justify-content: left;
}
.c-row.category {
  border-bottom: 1px #ffffff solid;
}
/* .c-row:nth-child(2n) {  
    background-color:#2c2c2c;
}
.c-row:nth-child(2n+1) {  
    background-color:#343434;color: white;
} */
.c-th,
.c-td,
.c-thead {
  display: flex;
  align-items: center;
  border: 0;
  flex-shrink: 0;
}
.c-td {
  justify-content: center;
  height: 3.5em;
}
.c-td.category-name {
  justify-content: left;
  cursor: pointer;
  font-weight: bold;
}
.c-td.feature-name {
  justify-content: left;
  padding-left: 10px;
}
.w3 {
  width: 24%;
}
.w1 {
  width: 8.33%;
}
.w2 {
  width: 16.66%;
}
.w4 {
  width: 33.32%;
}
.w5 {
  width: 41.65%;
}
.w12 {
  width: 100%;
}
.th-f.price {
  font-size: 100%;
}
.c-input {
  color: #fff;
  text-align: center;
}
/** table header start */
.span2C {
  padding: 20px 0 0 0;
  background-image: linear-gradient(37deg, #bf8b2a, #eac677, #f2d785, #f2d06b, #bf8b2a);
}
.th-f {
  font-size: 140%;
  text-align: center;
  color: #000000;
  font-weight: bold;
}
.c-td-title {
  font-size: 110%;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
}
/** table feature category */
.c-thead {
  background-image: linear-gradient(90deg, #f2d06b, #f2d785, #f2d06b);
  justify-content: flex-start;
  height: 3em;
  color: #000000;
  border-top: 1px solid #bf8b2a;
}
.wadj {
  flex-grow: 1;
}
.c-h1 {
  font-size: 110%;
  margin: 0;
  padding: 0;
  padding-left: 10px;
}
/** 功能 */
.c-title {
  font-weight: bold;
}
.c-subtitle {
  justify-content: flex-start;
  border-right: 1px solid #000;
  font-weight: bold;
}
.c-arrow {
  padding: 0px 10px;
}
.c-row.deactivate-detail {
  display: none;
}
</style>
